import React, {useEffect, useState} from 'react';
import {coy} from "react-syntax-highlighter/dist/cjs/styles/prism";
import {Prism as SyntaxHighlighter} from "react-syntax-highlighter";


const LinkExample = (props) => {
    const {method, url, data, headers, paramsType, changeCodeText, customStyle, secretKey} = props;
    const [codeText, setCodeText] = useState('');

    const getParamString = () => {
        let paramsString = ``;

        const params = data;
        for(let name in params) {
            if (name == "clientId") {
                continue;
            }
            paramsString += `&${name}=${params[name]}`;
        }
        paramsString += `&sign=${headers['sign']}`
        return paramsString;
    };
    const getDataString = () => {
        const dataValue = getParamString();
        const dataString = dataValue;
        return dataString;
    };
    useEffect(() => {
        const dataString = getDataString();
        const codeStrings = [
            `${url}`+`${dataString}`,
        ].filter(str => str !== null);
        setCodeText(codeStrings.join('\n'));
        changeCodeText(codeText);
    });

    return (
            <div className="link-example">
                <a target='_blank' rel='noopener noreferrer' href={codeText}>
                    <SyntaxHighlighter
                            language="bash"
                            style={coy}
                            wrapLines={true}
                            customStyle={customStyle}
                    >
                        {codeText}
                    </SyntaxHighlighter>
                </a>
            </div>
    );
}


export default LinkExample;
